// extracted by mini-css-extract-plugin
module.exports = {"TestOnWay":"OnItsWay_TestOnWay__2eiMI","TestOnWaySubTitle":"OnItsWay_TestOnWaySubTitle__1yikg","TestOnWayHomeLink":"OnItsWay_TestOnWayHomeLink__2-8YH"};